import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import Constants from '../Constants';

import { useNavigate, useSearchParams } from 'react-router-dom';

import wordmark from '../assets/menu-wordmark.png';
import '../App.css';

// The plan a marketing page link names. The marketing site cannot write this app's localStorage,
// so it passes the plan by name and interval in the query string and the plan is looked up here.
const find_linked_plan = (plans, plan_name, billing_interval) => {
  return plans.find(function(plan) {
    return plan.is_active && (plan.name === plan_name) && (plan.billing_interval === billing_interval);
  });
};

function SignupView() {
  const [search_params] = useSearchParams();
  const linked_plan_name = search_params.get('plan_name');
  const linked_billing_interval = search_params.get('billing_interval');
  const has_linked_plan = Boolean(linked_plan_name && linked_billing_interval);

  // A link that names a plan wins over whatever an earlier visit left stored, so going back to
  // the marketing page and choosing a different plan shows that plan here.
  const plan_json = has_linked_plan ? null : localStorage.getItem(Constants.SIGNUP_SELECTED_PLAN);
  const [checkout_plan, set_checkout_plan] = useState(plan_json ? JSON.parse(plan_json) : null);

  // const [email, setEmail] = useState(Constants.TEST_SIGNUP_EMAIL);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [signup_coupon, setSignupCoupon] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(function() {
    if(!has_linked_plan) {
      return;
    }

    const load_linked_plan = async () => {
      try {
        const response = await axios.get(Constants.SERVER_URL + '/api/plans');
        const raw = response.data;
        const plans = Array.isArray(raw) ? raw : (raw.plans || []);
        const linked_plan = find_linked_plan(plans, linked_plan_name, linked_billing_interval);
        if(linked_plan) {
          localStorage.setItem(Constants.SIGNUP_SELECTED_PLAN, JSON.stringify(linked_plan));
          set_checkout_plan(linked_plan);
        }
      } catch (error) {
        setError('Failed to load the selected plan.');
      }
    };
    load_linked_plan();
  }, [has_linked_plan, linked_plan_name, linked_billing_interval]);

  const handle_send = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if(!email || !password || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if(password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      localStorage.setItem(Constants.SIGNUP_USER_EMAIL, email,  { path: "/" });

      var plan_id = null;
      if(checkout_plan){
        plan_id = checkout_plan.id;
      }

      const url = Constants.SERVER_URL + '/api/auth/register';
      const response = await axios.post(url, {
        email: email,
        password: password,
        signup_coupon: signup_coupon,
        plan_id
        // plan_json
      });

      if(response.status === 200 || response.status === 201) {
        setSuccess(true);
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        // navigate('/plans');
        navigate('/verification_email_sent');
        

      } else {
        setError('Unexpected response from server.');
      }
    } catch (error) {
      if(error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);

        if(error.response.data.message == 'User already exists'){
          setTimeout(()=>{ navigate('/login'); }, 1500);
        }

      } else {
        setError('Failed to connect to server.');
      }
    }
  };

  const render_form_input = (controlId, label, type, placeholder, value, setter, required=true) => {
    return (
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e.target.value)}
          required={required}
        />
      </Form.Group>
    );
  };




  return (
    <Container fluid className="auth-container">
      <Row className="auth-row">
        <Col lg={4} md={6} sm={10} xs={11}>
          <Card className="auth-card">
            <Card.Body className='auth-card-body'>
              <img src={wordmark} className="signin-logo"/>
              <h3 className='auth-title'>Sign Up</h3>

              {checkout_plan ? (
                <div className="signup-checkout-plan">
                  <span className="signup-checkout-plan-label">Selected plan:</span>
                  <span className="signup-checkout-plan-name">{checkout_plan.name}</span>
                  <span className="signup-checkout-plan-price">{'$' + (checkout_plan.price_in_cents / 100).toFixed(2) + ' / ' + Constants.get_billing_interval_label(checkout_plan.billing_interval)}</span>
                </div>
              ) : null}

              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">Signup successful!</Alert>}

              <Form onSubmit={handle_send}>
                <Row className="mx-0">
                  {render_form_input('signupEmail', 'Email address', 'email', 'Enter email', email, setEmail)}
                </Row>
                <Row className="mx-0">
                  {render_form_input('signupPassword', 'Password', 'password', 'Enter password', password, setPassword)}
                </Row>
                <Row className="mx-0">
                  {render_form_input('signupConfirmPassword', 'Confirm Password', 'password', 'Confirm password', confirmPassword, setConfirmPassword)}
                </Row>
                
                <div className="d-grid mt-2 form-button auth-form-button">
                  <Button variant="primary" type="submit">Create Account</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default SignupView;
